import { lazy } from "react";
import { SEASON_01, SEASON_02 } from "../constants/seasons.ts";
import { currentSeason } from "../services/currentSeason.ts";

const paths = {
  [SEASON_01]: {
    mainMenu: lazy(() => import("./season-01/FragmentMainMenu.tsx")),
    courseComplete: lazy(
      () => import("./season-01/fragment-course-complete/FragmentCourseComplete.tsx"),
    ),
  },
  [SEASON_02]: {
    mainMenu: lazy(() => import("./season-02/FragmentMainMenu.tsx")),
    courseComplete: lazy(
      () => import("./season-02/fragment-course-complete/FragmentCourseComplete.tsx"),
    ),
  }
}

export const FRAGMENTS = paths[currentSeason as keyof typeof paths];

export type FragmentsKey = keyof typeof FRAGMENTS;
